<template>
    <div class="common-title">
        <h3>{{title}}</h3>
        <h3>{{subTitle}}</h3>
    </div>
</template>

<script>
export default {
  name: "Title",
  props: {
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      }
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.common-title{
    text-align: center;
    font-size: 15px;
    color: #282828;
    font-family: PingFangSC-Semibold;
    position: relative;
    padding-bottom: 7px;
    box-sizing: border-box;
}

.common-title:before{
    content: '';
    display: block;
    width: 100px;
    height: 1px;
    background: #DEDEDE;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -50px;
}

.common-title:after{
    content: '';
    display: block;
    width: 20px;
    height: 3px;
    background: #398DEE;
    position: absolute;
    bottom: -1px;
    left: 50%;
    margin-left: -10px;
    border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Title/Title.vue